module.exports = __webpack_public_path__ + "img/dateTop2.411d80f0.png";